// extracted by mini-css-extract-plugin
export default {"innerWrapper":"oA-z","tooltipWrapper":"pA-z","icon":"qA-z","tooltip":"rA-z","content":"sA-z"};